import * as React from "react";
import { addSlash } from "../../utils";
import { useState } from "react";
const Alert = ({ data }) => {
  const [close, setClose] = useState(false);

  return (
    <>
      {!close ?
        <div className="alert col-span-12">
          <div clclassNameass="info">
            <span className="icon">!</span>
            <span className="text">Alert</span>
          </div>
          <div className="title">{data.title}</div>
          <div className="action">
            <a href={addSlash(data.url)} aria-label={`${data.urltext} about ${data.title}`}>{data.urltext}</a>
          </div>
          <div className="close">
            <button className="close-alert" role="button" aria-label="Close alert" onClick={() => setClose(true)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill-rule="evenodd"
                  fill="#fff"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-linejoin="bevel"
                  stroke="#fff"
                  d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
        : null}
    </>
  );
};

export default Alert;
